import { memo } from "react";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

type Props = {
	id: string;
	title: string;
	children: React.ReactNode;
};

export const AccordionLayout = memo(({ id, title, children }: Props) => {
	return (
		<Accordion type="single" collapsible>
			<AccordionItem value={id}>
				<AccordionTrigger>
					<p>{title}</p>
				</AccordionTrigger>

				<AccordionContent>
					<div className="p-3">{children}</div>
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
});
